
export enum CustomerMatchResultTypeCd {
	ALIAS = 'Alias',
	CUSTOMER = 'Customer'}

